import _defineProperty from "@babel/runtime/helpers/defineProperty";
import classNames from 'classnames';
import React from 'react';
var css = {
  "radioBtn": "rui-pFk9o",
  "checked": "rui-lZmqe"
};
var Radio = function Radio(_ref) {
  var id = _ref.id,
    name = _ref.name,
    value = _ref.value,
    checked = _ref.checked,
    className = _ref.className,
    extras = _ref.extras,
    onClick = _ref.onClick;
  var handleOnClick = function handleOnClick(event) {
    var checked = event.target.checked;
    onClick({
      id: id,
      name: name,
      value: value,
      checked: checked
    });
  };
  return /*#__PURE__*/React.createElement("input", Object.assign({
    id: id,
    name: name,
    key: "new-radio-field",
    type: "radio",
    value: value,
    onClick: handleOnClick,
    className: classNames(css.radioBtn, _defineProperty({}, css.checked, checked), className)
  }, extras));
};
Radio.defaultProps = {
  checked: false,
  extras: {},
  className: ''
};
export default Radio;